module.exports = __webpack_public_path__ + "static/media/stamp.ea6ba874.svg";